export default __webpack_public_path__ + "static/media/file.bb2ff351.svg";